import { render, staticRenderFns } from "./BlogAdmin.vue?vue&type=template&id=74d79bf4"
import script from "./BlogAdmin.vue?vue&type=script&lang=ts"
export * from "./BlogAdmin.vue?vue&type=script&lang=ts"
import style0 from "./BlogAdmin.vue?vue&type=style&index=0&id=74d79bf4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports